import NoticeComponent from "../../components/NoticeComponent";
import ProfileSidebar from "../../components/ProfileSidebar";
import { useState } from "react";

export default function CouponPage() {
  const [couponCode, setCouponCode] = useState("");
  const [couponMessage, setCouponMessage] = useState("사용 가능한 쿠폰이 없습니다. 쿠폰을 등록해주세요.");

  const handleCouponRegister = () => {
    if (couponCode === "") {
      setCouponMessage("쿠폰 코드를 입력해주세요.");
    } else {
      setCouponMessage(`쿠폰 코드 '${couponCode}'이(가) 등록되었습니다.`);
    }
  };

  return (
    <section className="mt-[90px] max-w-[1440px] w-full mx-auto h-screen">
      <div className="flex flex-col flex-1 w-full">
        <div className="flex items-stretch flex-row justify-between w-full mx-auto">
          {/* 사이드바 */}
          <ProfileSidebar />
          {/* 프로필 콘텐츠 */}
          <article className="h-full w-full">
            <div className="w-full h-full flex flex-row items-start ">
              <div className="max-w-[1440px] w-full px-[80px] pt-[48px] pb-[80px]">
                <div>
                  <NoticeComponent title="쿠폰" content="쿠폰 코드 입력" />
                  {/* 쿠폰 입력 영역 */}
                  <div className="mt-8 max-w-[600px] w-full ">
                    <div className="flex items-center gap-3">
                      <input
                        type="text"
                        value={couponCode}
                        onChange={(e) => setCouponCode(e.target.value)}
                        placeholder="쿠폰 코드를 입력해주세요."
                        className="w-full text-base shadow-sm outline-none border bg-slate-50 border-gray-300 text-[#555] font-medium rounded px-4 py-4"
                      />


                      <button
                        onClick={handleCouponRegister}
                        className="bg-gray-400 hover:bg-gray-300 transition duration-300 ease-in-out text-white shadow-sm tracking-wide text-nowrap h-full text-base font-medium rounded px-4 py-4"
                      >
                        쿠폰등록
                      </button>
                    </div>
                    {/* 쿠폰 상태 메시지 */}
                    <div className="flex flex-col mt-16 text-center">
                      <div className="text-[100px] text-gray-300">%</div>
                      <p className="text-gray-400 mt-4">{couponMessage}</p>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
